import { render, staticRenderFns } from "./CariKartlarDetayButon.vue?vue&type=template&id=01b915c3&"
import script from "./CariKartlarDetayButon.vue?vue&type=script&lang=js&"
export * from "./CariKartlarDetayButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports